import { render, staticRenderFns } from "./ViewDestination.vue?vue&type=template&id=5bd28c7b&scoped=true"
import script from "./ViewDestination.vue?vue&type=script&lang=js"
export * from "./ViewDestination.vue?vue&type=script&lang=js"
import style0 from "./ViewDestination.vue?vue&type=style&index=0&id=5bd28c7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd28c7b",
  null
  
)

export default component.exports